
import React, {Component} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import HeaderComponent from "../../components/header/HeaderComponent";
import CLINotificationCard from "./CLI/NotificationCard";
import CLINotificationDetail from "./CLI/NotificationDetail";
import ManualOrderAcceptanceCard from "./ManualOrderAcceptance/NotificationCard";
import ManualOrderAcceptanceDetail from "./ManualOrderAcceptance/NotificationDetail";

const arraySort = require('array-sort');
const translator = require('../../utils/translator/translator');
const logger = require('../../utils/logger/logger');
var stateManager = require('../../utils/state/stateManager.js');
var stringUtil = require('../../utils/string/stringUtil');
var userNotificationsUtil = require('../../utils/userNotifications/userNotificationsUtil');
var navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction');

class NotificationsView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.selectedNotificationId = null

        if (this.props.selectedNotificationId != null)
            this.state.selectedNotificationId = this.props.selectedNotificationId;
    }

    render()
    {
        var userNotifications = this.getSortedNotifications();
        if (this.state.selectedNotificationId == null || 
            userNotifications.find(notification => stringUtil.areStringSame(notification.id, this.state.selectedNotificationId)) == null)
        {
            this.state.selectedNotificationId = null;
            if (userNotifications.length > 0)
                this.select(userNotifications[0]);
        }

        return <div className='h-100 w-100 d-flex flex-column'>
                    <div>
                        {this.renderToolbar()}
                    </div>
                    <div className='h-100 w-100 d-flex' style={{overflowY:'auto'}}>
                        {this.renderBody(userNotifications)}
                    </div>
                </div>
    }

    renderToolbar()
    {
        return <HeaderComponent title={translator.getLabel("notifications")}>
                    
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{textAlign:'end'}}>
                                <Button className='btn-cancel'
                                    onClick={()=>
                                        {
                                            logger.usage("Notifications.Exit", "Staff clicked exit button to exit");
                                            stateManager.getStore().dispatch(navigationPageAction.createAction(null));
                                        }}>{translator.getLabel("exit")}</Button>
                            </td>
                        </tr>
                    </table>
                </HeaderComponent>
    }

    renderBody(userNotifications)
    {
        if (userNotifications.length <= 0)
        {
            return <div className='w-100 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                                    <div>
                                        {translator.getLabel("no_notifications_found")}   
                                    </div>                            
                    </div>
        }

        return <div className='h-100 w-100 d-flex flex-row'>
                    <div className='h-100 d-flex flex-column' style={{minWidth:'40vw', maxWidth:'40vw', paddingLeft:'20px', paddingRight:'20px', paddingTop:'10px', paddingBottom:'10px', overflowY:'auto'}}>
                        <div>{this.renderLeftBar(userNotifications)}</div>
                    </div>

                    <div className='h-100 w-100' style={{overflowY:'auto', background:'white', paddingLeft:'20px', paddingRight:'20px', paddingTop:'10px', paddingBottom:'10px'}}>
                        {this.renderRightBar(userNotifications)}
                    </div>
                   
                </div>
    }

    renderLeftBar(userNotifications)
    {
        let components = [];
        userNotifications.forEach (userNotification =>
        {
            let border = userNotification.id != this.state.selectedNotificationId ? null : "3px solid var(--colors-error)";
            var background = userNotification.id != this.state.selectedNotificationId ? null : "var(--colors-white)";
            if (userNotification.type == "cli.onHold")  
                components.push(<div    style={{marginBottom:'15px', border:border, background:background}} 
                                        onClick={()=>
                                        {
                                            if (this.state.selectedNotificationId == userNotification.id)
                                                return;

                                            this.select(userNotification);
                                            this.setState({});
                                        }}>
                                    <CLINotificationCard notification={userNotification}/>
                                </div>)
            else
                components.push(<div    style={{marginBottom:'15px', border:border, background:background}} 
                                        onClick={()=>
                                        {
                                            if (this.state.selectedNotificationId == userNotification.id)
                                                return;

                                            this.select(userNotification);
                                            this.setState({});
                                        }}>
                                    <ManualOrderAcceptanceCard notification={userNotification}/>
                                </div>)
                                        
        })

        return <div className='h-100'>
                    {components}
               </div>
    }

    renderRightBar(userNotifications)
    {
        if (this.state.selectedNotificationId == null)
            return null;

        var userNotification = userNotifications.find(n => stringUtil.areStringSame(n.id, this.state.selectedNotificationId));
        if (userNotification == null)
            return null;

        if (userNotification.type == "cli.onHold")  
            return <div>
                        <CLINotificationDetail key={this.state.selectedNotificationId} notification={userNotification}/>
                    </div>

        return <div>
                        <ManualOrderAcceptanceDetail key={this.state.selectedNotificationId} notification={userNotification}/>
                </div>
    }

    select(userNotification)
    {
        this.state.selectedNotificationId = userNotification.id;
        userNotification.isRead = true;
    }

    getSortedNotifications()
    {
        return arraySort(Array.from(userNotificationsUtil.userNotifications), 'expiryDateTime', {reverse:true});
    }


}

const mapStateToProps = state => 
{
    return { 
                userNotificationLastAddedDateTime: state.userNotificationLastAddedDateTime,
          }
}

export default connect(mapStateToProps)(NotificationsView)